module.exports = __webpack_public_path__ + "static/img/weather47.059281fa.png";